<!-- TEMPLATE -->
<template>
  <div class="row">
    <div class="col-lg-12">
      <v-card color="#272a3d" dark width="100%">
        <v-card-title>
          Tickets for {{ activeDomain }}

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-card-title v-if="selectedRows.length > 0">
          <v-row>
            <v-col lg="6">
              <v-row>
                <v-col sm="1" lg="1">
                  <v-btn
                    rounded
                    icon
                    @click="deleteRows()"
                    class="btn btn-icon"
                    dark
                  >
                    <v-icon color="red"> mdi-delete </v-icon>
                  </v-btn>
                </v-col>
                <v-col sm="3" lg="3">
                  <v-select
                    style="margin-top: 3px; margin-left: -12p"
                    align="center"
                    label="status"
                    outlined
                    dense
                    v-model="selectedStatus"
                    :items="this.status"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-btn
                    rounded
                    icon
                    style="margin-left: -12px"
                    @click="updateStatusRows()"
                    class="btn btn-icon"
                    dark
                  >
                    <v-icon color="white">mdi-content-save</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="columns"
          :items="websites"
          :search="search"
          :sort-by="['lastseen']"
          :sort-desc="[true]"
          dense
          show-select
          v-model="selectedRows"
          class="mytable"
          :loading="noDataLoading"
          loading-text="Loading tickets... Please wait"
        >
          <template v-slot:item.hits="{ item }">
            <v-chip :color="getColorVisits(item.hits)" dark small>{{
              item.hits
            }}</v-chip>
          </template>

          <template v-slot:item.credentials="{ item }">
            <v-chip :color="getColorHijackedCreds(item.hits)" dark small>{{
              item.credentials
            }}</v-chip>
          </template>

          <template v-slot:item.lastseen="{ item }">
            <v-chip small>{{ item.lastseen | toReadableDate }}</v-chip>
          </template>

          <template v-slot:item.up="{ item }">
            <v-switch
              v-model="item.up"
              @change="changeStateUpDown(item.id, item.up)"
              single-line
              counter
              color="red"
              autofocus
            >
            </v-switch>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              v-if="getTicketStatus(item) == 'open'"
              :color="'orange'"
              small
              >{{ getTicketStatus(item) }}</v-chip
            >
            <v-chip
              v-else-if="getTicketStatus(item) == 'verified'"
              :color="'red'"
              small
              >{{ getTicketStatus(item) }}</v-chip
            >
            <v-chip
              v-else-if="getTicketStatus(item) == 'reported'"
              :color="'primary'"
              small
              >{{ getTicketStatus(item) }}</v-chip
            >
            <v-chip
              v-else-if="getTicketStatus(item) == 'resolved'"
              :color="'green'"
              small
            >
              {{ getTicketStatus(item) }}</v-chip
            >
            <v-chip v-else :color="'grey'" small>{{
              getTicketStatus(item)
            }}</v-chip>
          </template>

          <template v-slot:item.detonate="{ item }">
            <v-btn
              @click.stop="openKillswitch(item.domain, item.id)"
              :key="item.id"
              :ref="item.id"
              :id="item.id"
              :color="getColorKillswitch(item.killswitch)"
              class="ma-2 btn"
              dark
              :disabled="item.source != 'agent'"
            >
              <v-icon dark>mdi-power-standby</v-icon>
            </v-btn>
            <v-dialog v-model="killswitchDialog[item.domain]" width="50%">
              <v-card>
                <v-card-title class="headline">
                  <span style="margin-right: 10px">
                    <v-icon color="red darken-2"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </span>
                  Activate killswitch
                </v-card-title>
                <v-card-text>
                  This action will make the phishing website
                  {{ item.domain }} not visible to the victims, but also to the
                  phishers.
                  <br />
                  Do you want to enable the killswitch?
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="ma-1 btn"
                    dark
                    @click="disableKillswitch(item.domain, item.id)"
                  >
                    Disable
                  </v-btn>
                  <v-btn
                    class="ma-2 btn btn-google"
                    dark
                    @click="enableKillswitch(item.domain, item.id)"
                  >
                    Enable
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-on:click="seeDetails(item.id)"
              :value="item.domain"
              class="btn btn-icon"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <template slot="no-data">
            <template v-if="noDataLoading">
              <v-progress-circular :size="50" color="primary" indeterminate>
              </v-progress-circular>
            </template>
            <template v-else> No data </template>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script>
//import UserInfoStore from '../app/user-info-store';
import PhishingApi from "../app/phishing-api";

export default {
  name: "Home",
  data: function () {
    return {
      selectedDomain: this.$store.getters.activeDomain,
      selectedStatus: "",
      search: "",
      selectedRows: [],
      columns: [
        { text: "Ticket ID", value: "id", sortable: true, align: "start" },
        { text: "URL", value: "lastseenurl", sortable: true, align: "start" },
        { text: "Domain", value: "domain", sortable: true, align: "start" },
        { text: "IP", value: "ip", sortable: true, align: "start" },
        {
          text: "Last Seen",
          value: "lastseen",
          sortable: true,
          align: "start",
        },
        { text: "Visited", value: "hits", sortable: true, align: "start" },
        {
          text: "Hijacked Credentials",
          value: "credentials",
          sortable: true,
          align: "start",
        },
        //{ text: 'Down/Up', value: 'up', sortable: true, align: 'start'},
        { text: "Source", value: "source", sortable: true, align: "start" },
        { text: "Status", value: "status", sortable: true, align: "start" },
        { text: "Detonate", value: "detonate" },
        { text: "Details", value: "actions" },
      ],
      status: ["open", "verified", "reported", "resolved"],
      killswitchDialog: {},
      noDataLoading: 0,
    };
  },
  mounted() {
    this.noDataLoading = 1;
    if (this.$store.state.activeDomain) this.fetchData();
  },
  computed: {
    activeDomain: function () {
      return this.$store.state.activeDomain;
    },
    websites: function () {
      return this.$store.state.phishingWebsites;
    },
  },
  methods: {
    getTicketStatus(item) {
      try {
        return item.status[item.status.length - 1].ticket;
      } catch (e) {
        return null;
      }
    },

    deleteRows() {
      this.noDataLoading = 1;
      let self = this;
      PhishingApi.deletePhishingWebsites(
        JSON.stringify(self.selectedRows)
      ).then(function () {
        self.noDataLoading = 0;
        self.$store.dispatch("refreshPhishingWebsites");
        self.$store.dispatch("refreshGraphs");
        self.selectedRows = [];
      });
    },
    updateStatusRows() {
      this.noDataLoading = 1;
      let self = this;
      PhishingApi.updateStatusPhishingWebsites(
        JSON.stringify(self.selectedRows),
        self.selectedStatus
      ).then(function () {
        self.noDataLoading = 0;
        self.$store.dispatch("refreshPhishingWebsites");
        self.$store.dispatch("refreshGraphs");
        self.selectedRows = [];
      });
    },

    changeStateUpDown(id, status) {
      let self = this;
      PhishingApi.setUpDownForDomain(id, status).then(function () {
        self.$store.dispatch("refreshPhishingWebsites");
        self.$store.dispatch("refreshGraphs");
      });
    },
    updateColor(color) {
      return color;
    },
    fetchData: function () {
      this.$store.dispatch("refreshPhishingWebsites");
      this.noDataLoading = 0;
    },
    getColorVisits: function (number) {
      if (number > 50) return "red";
      else if (number > 20) return "orange";
      else return "green";
    },
    getColorHijackedCreds: function (number) {
      if (number > 10) return "red";
      else if (number > 4) return "orange";
      else return "green";
    },
    getColorKillswitch: function (v) {
      return v ? "btn-warning" : "btn-icon";
    },
    getStatus: function (v) {
      return v ? "green" : "grey";
    },
    seeDetails: function (value) {
      this.$store.commit("setDetailsDomain", value);
      this.$router.push("details");
    },
    updateStatus: function (v) {},
    cancel: function () {},
    open: function () {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    },
    openKillswitch: function (domain, id) {
      //this will open the dialog
      this.$set(this.killswitchDialog, domain, true);
    },
    enableKillswitch: function (domain, id) {
      let self = this;
      PhishingApi.setKillswitchForDomain(true, id).then(function () {
        self.$set(self.killswitchDialog, domain, false);
        self.fetchData();
      });
    },
    disableKillswitch: function (domain, id) {
      let self = this;
      PhishingApi.setKillswitchForDomain(false, id).then(function () {
        self.$set(self.killswitchDialog, domain, false);
        self.fetchData();
      });
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    boolToUpDown(value) {
      return value ? "up" : "down";
    },
  },
  components: {},
};
</script>

<!-- Style -->
<style>
</style>